var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('content-card',{attrs:{"title":_vm.title || _vm.$t('regionsCarbonTableCard.title'),"caption":_vm.$t('regionsCarbonTableCard.subtitle')}},[_c('regions-carbon-table',_vm._g(_vm._b({},'regions-carbon-table',_vm.$props,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }